const statusLabels = {
  sold_out: "sold out",
  forced_sold_out: "sales stopped",
  pending_approval: "pending approval",
};

export function formatStatus(statusString) {
  return statusLabels[statusString] ?? statusString;
}

export function formatSalesWindow(salesStart, salesEnd) {
    const start = new Date(salesStart);
    const end = new Date(salesEnd);

    const hasValidWindow =
        salesStart &&
        salesEnd &&
        !Number.isNaN(start.getTime()) &&
        !Number.isNaN(end.getTime());

    if (!hasValidWindow) {
        return "Always available";
    }

    const formatter = new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
    });

    return `${formatter.format(start)} – ${formatter.format(end)}`;
}

export function formatOrderDate(value) {
  const [time, date] = value.trim().split(/\s+/);
  const [day, month, year] = date.split("/");

  const formattedDate = new Date(`${year}-${month}-${day}T${time}`);

  return formattedDate.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function formatInventory(inventoryCap) {
  if (inventoryCap === null) return "Unlimited";
  return `${inventoryCap} ${inventoryCap === 1 ? "ticket" : "tickets"}`;
}